<template>
  <b-row class="slack-review-wrapper">
    <b-col>
      <div class="border" style="background: #f9fbfe">
        <div class="d-flex p-3">
          <div class="d-flex">
            <div class="avatar">
              <avatar :user="user" :size="40"/>
            </div>
          </div>
          <div>
            <p class="headline mb-0"><strong>{{ user.fullName }} <small class="ml-3 text-muted">9.30AM</small></strong></p>
            <div class="d-flex flex-column flex-wrap" style="word-break: break-all">
              <slot></slot>
            </div>
          </div>
        </div>
        <hr />
        <div class="d-flex justify-content-end pb-3 px-3">
          <b-button
            variant="outline-primary"
            size="sm"
            @click="$emit('sendTestMessage')"
            :disabled="sendTestMessageButtonDisabled"
          >
            Send Test<font-awesome-icon class="ml-2" icon="paper-plane"/>
          </b-button>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import Avatar from '@/components/users/Avatar';
import { mapRoot } from '@/mixins/root';

export default {
  components: {
    Avatar,
  },
  props: {
    sendTestMessageButtonDisabled: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapRoot([ 'user' ]),
  }
};
</script>

<style lang="scss">
.slack-review-wrapper {
  .avatar {
    width: 60px;
  }
  .headline {
    font-size: 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/campaign-admin/message-previews/slack/wrapper.vue